<template>
  <div class="content">
    <h1 class="has-text-centered">Fehlersuche in Netzwerken</h1>
    <div class="box">
      <p>Eine kompakte Zusammenfassung über Fehlersuche in Netzwerken.</p>
      <FAQsTableOfContents :faqs="faqs" />
    </div>

    <div class="box">
      <FAQs :faqs="faqs" :h_level="2" />
    </div>

    <FeedbackBox />
  </div>
</template>

<script>
import FeedbackBox from '@/components/FeedbackBox.vue'
import FAQs from '@/components/FAQs.vue'
import FAQsTableOfContents from '@/components/FAQsTableOfContents.vue'

export default {
  name: 'theory-network-debugging',
  components: {
    FeedbackBox,
    FAQs,
    FAQsTableOfContents
  },
  metaInfo: {
    title: 'Fehlersuche in Netzwerken | Elektrotechnik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Eine kompakte Zusammenfassung über Fehlersuche in Netzwerken.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'network-engineering' })
  },
  data () {
    return {
      faqs: [
        {
          question: 'Wo fängt man bei der Fehlersuche in Netzwerken an?',
          answer:
            '<ul>' +
            '  <li>Für ein strukturiertes Vorgehen orientiert man sich am - jede Schicht wird, angefangen bei der untersten, wird auf Fehler überprüft</li>' +
            '  <li>In den höheren Schichten steigt die Anzahl an möglichen Fehlerquellen und auch die Fehler selbst werden komplexer</li>' +
            '</ul>'
        },
        {
          question: 'Welche Kommandozeilen Werkzeuge können bei der Fehlersuche in Netzwerken helfen?',
          answer:
            '<ul>' +
            '  <li><strong>ping</strong></li>' +
            '  <ul>' +
            '    <li>Überprüft ob ein bestimmter Host in einem IP-Netzwerk erreichbar ist</li>' +
            '  </ul>' +
            '  <li><strong>nslookup</strong></li>' +
            '  <ul>' +
            '    <li>Der Name des Befehls bedeutet "Name Server look up"</li>' +
            '    <li>Gibt IP-Adressen oder Domains eines bestimmten Computer mittels DNS (Domain Name System) zurück</li>' +
            '    <li>Modernere Alternative ist der Befehl <strong>dig</strong></li>' +
            '  </ul>' +
            '</ul>'
        },
        {
          question: 'Was sind mögliche Fehlerquellen für Probleme im Netzwerk?',
          answer:
            '<ul>' +
            '  <li><strong>Netzwerkkabel</strong></li>' +
            '  <ul>' +
            '    <li>Blinken die grünen LEDs (soweit vorhanden) an den Anschlüssen?</li>' +
            '    <li>Sitzen sie fest und sind richtig angeschlossen?</li>' +
            '  </ul>' +
            '  <li><strong>Adressierung</strong></li>' +
            '  <ul>' +
            '    <li>Ist die Konfiguration des Namensdienste fehlerhaft?</li>' +
            '    <li>Wird die MAC- und IP-Adresse richtig gesetzt?</li>' +
            '  </ul>' +
            '  <li><strong>Routingfehler</strong></li>' +
            '  <ul>' +
            '    <li>Sind mögliche IP-Subnetze richtig verbunden?</li>' +
            '    <li>Arbeiten IP-Router nach Vorgabe?</li>' +
            '  </ul>' +
            '  <li><strong>File Check Sequence Errors</strong></li>' +
            '  <ul>' +
            '    <li>Jedes Paket enthält eine sogenannte File Check Sequence (damit kann der Empfänger feststellen ob das Paket komplett ist)</li>' +
            '    <li>Fehler werden oft durch ein Netzwerkrauschen verursacht</li>' +
            '    <li>Rauschen kann verursacht werden durch:</li>' +
            '    <ul>' +
            '      <li>Herunter-, Hochfahren eines Computers während einer Übertragung</li>' +
            '      <li>Kabel liegen in der Nähe von Quellen welche Rauschen verursachen</li>' +
            '    </ul>' +
            '  </ul>' +
            '  <li><strong>Alignment Errors</strong></li>' +
            '  <ul>' +
            '    <li>Ausrichtungsfehler</li>' +
            '    <li>Tritt auf wenn ein Frame eine ungerade Anzahl an Bytes aufweist und nicht durch acht teilbar ist</li>' +
            '    <li>Fehler könnte in Kombination mit einem File Check Sequence Error auftreten</li>' +
            '    <li>Ursachen können Verkabelungsprobleme, Rauschen oder fehlerhafte LAN-Treiber sein</li>' +
            '  </ul>' +
            '  <li><strong>CRC-Fehler</strong></li>' +
            '  <ul>' +
            '    <li>Cyclical Redundancy Check(zyklische Redundanzprüfung)</li>' +
            '    <li>Kombination aus Ausrichtungs- und Checksummenfehler</li>' +
            '    <li>Ein Computer kann die Verbindung nicht aufrechterhalten</li>' +
            '    <li>Grund kann eine defekte Netzwerkkarte sein</li>' +
            '  </ul>' +
            '  <li><strong>Discards</strong></li>' +
            '  <ul>' +
            '    <li>Treten auf wenn ein Puffer zu voll ist und das Netzwerk das Paket nicht aufnehmen kann (Übertragungs-Discards)</li>' +
            '    <li>Können auch auftreten bei einem Stau im Netzwerk der verhindert, dass das Paket auf einen höher gelegenen Layer transportiert werden kann (Empfangs-Discard)</li>' +
            '  </ul>' +
            '</ul>'
        }
      ]
    }
  }
}
</script>
